import React from 'react';

import { Logout } from '../components';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch = async (error, info) => {
    console.error('A client error occured', { error, info });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className='status-page'>
          <Logout />
          <h1 className='status-title'>
            An error occured, please try again later
          </h1>
        </div>
      );
    }

    return this.props.children;
  }
}
